import { render, staticRenderFns } from "./markdelivery.vue?vue&type=template&id=4bdc25a6"
import script from "./markdelivery.vue?vue&type=script&lang=js"
export * from "./markdelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports